const isLocalhost =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

// Deployment default: same-origin (Caddy reverse_proxy handles /api, /login, /oauth2).
// If is localhost, use localhost:81, if not, use same-origin (empty string).
export const API_URL_All = isLocalhost ? "http://localhost:8080" : "";
export const API_URL = API_URL_All;
export const API_URL_All0 = API_URL_All;
